import React from "react";
import { FormattedHTMLMessage, FormattedMessage } from "react-intl";
import { Box, Typography } from "@material-ui/core";
import TipBox from "../../TipBox";
import LabelIcon from "@material-ui/icons/Label";
import SectionTitle from "./SectionTitle";

const TableActionsHelp = ({ showCopy, showColumns, showHeaderClick }) => {
  const tableActions = [
    showCopy && { id: "app.report.button.copy", description: true },
    showColumns && { id: "app.report.button.columns", description: true, alert: true, tip: true },
    showHeaderClick && { id: "app.report.columns.header.click", description: true, alert: true },
  ].filter(Boolean);

  return (
    <>
      <SectionTitle icon={LabelIcon}>
        <FormattedMessage id="app.report.table.actions" />
      </SectionTitle>

      {tableActions.map(({ id, description, alert, tip }) => (
        <Box
          mb={1}
          key={id}
        >
          <Typography
            variant="body1"
            color="primary"
            gutterBottom
          >
            <FormattedHTMLMessage id={id} />
          </Typography>
          {description && (
            <Typography
              variant="body1"
              paragraph
            >
              <FormattedHTMLMessage id={`${id}.description`} />
            </Typography>
          )}
          {alert && (
            <TipBox>
              <FormattedHTMLMessage id={`${id}.alert`} />
            </TipBox>
          )}
          {tip && (
            <TipBox>
              <FormattedHTMLMessage id={`${id}.tip`} />
            </TipBox>
          )}
        </Box>
      ))}
    </>
  );
};

export default TableActionsHelp;
